import React, { useState } from "react";
import { useSelector } from "react-redux";
import { Button } from "./Elements";
import { TabBar } from "../TabBar";

export const Flagged = ({
  display,
  questions = [],
  comments = [],
  socketRef,
  liveEvent,
  setQuestions,
  setComments,
  height,
  updateMessage,
}) => {
  const [selectedTab, setSelectedTab] = useState("Questions");
  const event_id = liveEvent?.public_id ?? liveEvent?.id;
  const { token } = useSelector((state) => state.users);

  return (
    <div
      style={{
        display: display ? "block" : "none",
        paddingTop: "20px",
        paddingLeft: "20px",
        height: height,
        overflow: "auto",
      }}
    >
      <TabBar
        tabs={["Questions", "Comments"]}
        counts={[
          questions.filter((q) => q.inappropriate).length,
          comments.filter((c) => c.inappropriate).length,
        ]}
        selectedTab={selectedTab}
        onSelect={(tab) => setSelectedTab(tab)}
      />
      <div
        style={{
          display: selectedTab === "Questions" ? "block" : "none",
          marginTop: "10px",
        }}
      >
        <ul>
          {questions.length > 0 ? (
            questions
              .filter((q) => q.inappropriate)
              .sort((a, b) => b.relevance - a.relevance)
              .map((question, index) => (
                <li
                  key={index}
                  style={{
                    fontSize: "16px",
                    marginBottom: "10px",
                    width: "100%",
                    border: "1px solid #d0d0d0",
                    borderRadius: "10px",
                    display: "flex",
                    alignItems: "flex-start",
                    justifyContent: "flex-start",
                    padding: "5px 10px",
                    flexDirection: "column",
                    // Light red
                    backgroundColor: "#ffe5e5",
                    borderColor: "#ff0000",
                  }}
                >
                  <div>{question?.message}</div>
                  <div
                    style={{
                      fontSize: "14px",
                      color: "#808080",
                      fontStyle: "italic",
                    }}
                  >
                    From: {question?.user.nickname}
                  </div>
                  <div
                    style={{
                      fontSize: "14px",
                      color: "#808080",
                      fontStyle: "italic",
                    }}
                  >
                    Marked Inappropriate: {question?.inappropriate_reason}{" "}
                  </div>
                  <div
                    style={{
                      display: "flex",
                      flexDirection: "row",
                      marginTop: "5px",
                      fontSize: "14px",
                      justifyContent: "space-around",
                      width: "100%",
                      flexWrap: "wrap",
                    }}
                  >
                    <Button
                      bgcolor="#f3f4f6"
                      textcolor="#334155"
                      onClick={() => {
                        console.log("!!! DISMISSING QUESTION: ", question);
                        question.status = "dismissed";
                        updateMessage(question);
                        socketRef.current.emit("update-message-status", {
                          token: token,
                          event_id: event_id,
                          broadcast_token: liveEvent?.broadcast_token, // Replace with actual token if needed
                          message_id: question.public_id,
                          status: "dismissed",
                        });
                        setQuestions((prevQuestions) =>
                          prevQuestions.filter(
                            (q) => q.public_id !== question.public_id
                          )
                        );
                      }}
                    >
                      <i className="fas fa-times"></i>
                      Dismiss
                    </Button>
                    <Button
                      bgcolor="#f3f4f6"
                      textcolor="#334155"
                      onClick={() => {
                        console.log("!!! APPROVING QUESTION: ", question);
                        console.log("!!! TOKEN: ", token);
                        question.status = "pending";
                        question.inappropriate = false;
                        updateMessage(question);
                        socketRef.current.emit("update-message-status", {
                          token: token,
                          event_id: event_id,
                          broadcast_token: liveEvent?.broadcast_token, // Replace with actual token if needed
                          message_id: question.public_id,
                          inappropriate: false,
                          status: "pending",
                        });

                        setQuestions((prevQuestions) =>
                          prevQuestions.map((q) =>
                            q.public_id === question.public_id
                              ? {
                                ...q,
                                status: "pending",
                                inappropriate: false,
                              }
                              : q
                          )
                        );
                      }}
                    >
                      <i className="fas fa-reply"></i>
                      Accept
                    </Button>
                  </div>
                </li>
              ))
          ) : (
            <li>No flagged questions.</li>
          )}
        </ul>
      </div>
      <div
        style={{
          display: selectedTab === "Comments" ? "block" : "none",
          marginTop: "10px",
        }}
      >
        <ul>
          {comments.length > 0 ? (
            comments
              .filter((c) => c.inappropriate)
              .sort((a, b) => a.updated_at < b.updated_at)
              .map((comment, index) => (
                <li
                  key={index}
                  style={{
                    fontSize: "16px",
                    marginBottom: "10px",
                    width: "100%",
                    border: "1px solid #d0d0d0",
                    borderRadius: "10px",
                    display: "flex",
                    alignItems: "flex-start",
                    justifyContent: "flex-start",
                    padding: "5px 10px",
                    flexDirection: "column",
                    // Light red
                    backgroundColor: "#ffe5e5",
                    borderColor: "#ff0000",
                  }}
                >
                  <div>{comment?.message}</div>
                  <div
                    style={{
                      fontSize: "14px",
                      color: "#808080",
                      fontStyle: "italic",
                    }}
                  >
                    From: {comment?.user.firstname} {comment?.user.lastname}
                  </div>
                  <div
                    style={{
                      fontSize: "14px",
                      color: "#808080",
                      fontStyle: "italic",
                    }}
                  >
                    Marked Inappropriate: {comment?.inappropriate_reason}{" "}
                  </div>
                  <div
                    style={{
                      display: "flex",
                      flexDirection: "row",
                      marginTop: "5px",
                      fontSize: "14px",
                      justifyContent: "space-around",
                      width: "100%",
                      flexWrap: "wrap",
                    }}
                  >
                    <Button
                      bgcolor="#f3f4f6"
                      textcolor="#334155"
                      onClick={() => {
                        console.log("!!! DISMISSING comment: ", comment);
                        comment.status = "dismissed";
                        updateMessage(comment);
                        socketRef.current.emit("update-message-status", {
                          event_id: event_id,
                          broadcast_token: liveEvent?.broadcast_token, // Replace with actual token if needed
                          message_id: comment.public_id,
                          status: "dismissed",
                        });
                        setComments((prevComments) =>
                          prevComments.filter(
                            (q) => q.public_id !== comment.public_id
                          )
                        );
                      }}
                    >
                      <i className="fas fa-times"></i>
                      Dismiss
                    </Button>
                    <Button
                      bgcolor="#f3f4f6"
                      textcolor="#334155"
                      onClick={() => {
                        console.log("!!! APPROVING comment: ", comment);
                        comment.status = "pending";
                        updateMessage(comment);
                        socketRef.current.emit("update-message-status", {
                          token: token,
                          event_id: event_id,
                          broadcast_token: liveEvent?.broadcast_token, // Replace with actual token if needed
                          message_id: comment.public_id,
                          inappropriate: false,
                          status: "pending",
                        });

                        setComments((prevComments) =>
                          prevComments.map((q) =>
                            q.public_id === comment.public_id
                              ? {
                                ...q,
                                status: "pending",
                                inappropriate: false,
                              }
                              : q
                          )
                        );
                      }}
                    >
                      <i className="fas fa-reply"></i>
                      Accept
                    </Button>
                  </div>
                </li>
              ))
          ) : (
            <li>No flagged comments.</li>
          )}
        </ul>
      </div>
    </div>
  );
};

export default Flagged;
